"use client"
import React from "react"
import "./Button.css"

const Button = ({
  children,
  variant = "",
  size = "large",
  className = "",
  onClick,
  disabled = false,
  ...props
}) => {
  const baseClass = "button"
  const variantClass = `button-${variant}`
  const sizeClass = `button-${size}`

  return (
    <button
      className={` ${sizeClass} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
